module.exports = __webpack_public_path__ + "static/media/on-eye_fresh-Grayzel.03e9496b.jpg";